<f-microsite site="good" color="#6a0966"
	video="https://player.vimeo.com/video/391592617?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
	title="Fathom For Good"
	videoPoster="/assets/images/video/good-poster.jpg">
	<ng-container headline>From fundraising communications to online giving, Fathom helps nonprofits
		make the world a better place.</ng-container>
	<ng-container asterisk>Fathom helps nonprofits communicate their mission and motivate supporters. In fact, we’ve helped raise hundreds of millions over the last 25 years!.</ng-container>

	<ng-container about>
		Fathom captures the authentic value of your nonprofit and plants seeds of
		generosity in the minds of your supporters.
	</ng-container>

	<ng-container about-identity>
		The right logo for your nonprofit or fundraising initiative captures your values,
		builds excitement, and invites people to participate.
	</ng-container>

	<ng-container about-design>
		From printed materials (or interactive pdfs) to websites, presentations,
		infographics, and more, great design differentiates your nonprofit and drives
		action.
	</ng-container>

	<ng-container about-development>
		Fathom’s web design solutions motivate donors. We can even follow through with
		integrated online giving solutions.
	</ng-container>

	<ng-container about-video>
		An explainer video can capture the hearts and minds of your audience. Or go
		further with a short documentary. We film and animate, but most of all, we
		motivate.
	</ng-container>
</f-microsite>
